import { Navigate } from "react-router-dom";

const ProtectedAdminRoute = ({ children }) => {
  const auth = JSON.parse(localStorage.getItem("auth")); // Ya context se bhi le sakte ho
  const user = auth?.user;

  if (!user || user.isAdmin !== true) {
    return <Navigate to="*" />;
  }

  return children;
};

export default ProtectedAdminRoute;
